import { IConsumptionsFilters } from "../models/Filters/ConsumptionsFilters";
import * as Functions from '../functions/common';
import { buildURL, buildHeaders, handleApiError } from './commons/CommonService.Functions';

// Base URL for Protocol Visits endpoints
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/visits/';

// Export protocol visits data as a file (Blob)
// GET: /protocols/visits/export
// Applies filters via query string using common helpers.
export const ExportAllProtocolVisits = async (
	filters: IConsumptionsFilters,
	token: string
): Promise<Blob> => {

	const params: URLSearchParams = Functions.GetQueryStringParams(
		undefined,
		undefined,
		filters?.FilterText,
		filters
	);

	const requestUrl = buildURL(BaseURL, 'export') + (params ? '?' + params.toString() : '');

	try {
		const response = await fetch(requestUrl, { 
			headers: buildHeaders(token),
			method: 'GET'
		});

		if (!response.ok) {
			throw response;
		}

		return await response.blob();
	} catch (error: any) {
		throw await handleApiError(error, 'ExportAllProtocolVisits');
	}
};

